export default __webpack_public_path__ + "static/media/phone.89ec61e0.svg";